import type * as React from 'react';

import { HeadEnabledContext } from './contexts';

/**
 * Enable/Disable the update on the head for components down the tree.
 */
export function EnableHead(props: {
    enabled: boolean;
    children: React.ReactNode;
}): React.ReactElement {
    const { enabled, children } = props;

    return <HeadEnabledContext.Provider value={enabled}>{children}</HeadEnabledContext.Provider>;
}
